import { T } from "../styles/theme";

interface HeaderBannerProps {
  weekDone: number;
  weekTotal: number;
}

/**
 * The top "LOOK at you DOING IT!" composition plus the weekly progress bar
 * underneath. Pure presentational; receives week totals via props.
 */
export function HeaderBanner({ weekDone, weekTotal }: HeaderBannerProps) {
  const weekPct = weekTotal ? Math.round((weekDone / weekTotal) * 100) : 0;
  return (
    <>
      <div
        style={{
          background: "linear-gradient(135deg,#1b608a,#2a84b5,#4aafd4)",
          // Top padding gives the "LOOK" block clearance from the viewport
          // edge, especially on phones where it was getting clipped.
          padding: "32px 0 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div style={{ position: "relative", textAlign: "center" }}>
          <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,400;0,900;1,700&family=Big+Shoulders+Display:wght@400&family=Saira+Extra+Condensed:wght@500&family=Pacifico&display=swap');
            .composition { position:relative; width:430px; height:375px; }
            .yellow-block { position:absolute; top:10px; left:10px; width:255px; height:185px; background-color:rgba(249,239,60,0.92); transform:rotate(2deg); mix-blend-mode:multiply; z-index:1; display:flex; align-items:flex-start; justify-content:center; padding:8px 20px 24px 20px; box-sizing:border-box; overflow:hidden; }
            .pink-block { position:absolute; top:180px; left:14px; width:380px; height:185px; background-color:rgba(238,150,220,0.88); transform:rotate(-3deg); mix-blend-mode:multiply; z-index:2; display:flex; align-items:flex-start; justify-content:center; padding:8px 20px 24px 20px; box-sizing:border-box; overflow:hidden; }
            .text-look { font-family:'Saira Extra Condensed',Impact,sans-serif; font-weight:500; font-size:160px; color:#1dcfbe; text-transform:uppercase; line-height:1; letter-spacing:-8px; white-space:nowrap; transform:rotate(0deg) scaleY(1.15); }
            .text-doingit { font-family:'Saira Extra Condensed',Impact,sans-serif; font-weight:500; font-size:160px; color:#f9c74f; text-transform:uppercase; line-height:1; letter-spacing:-4px; white-space:nowrap; transform:rotate(0deg) scaleY(1.15); }
            .text-atyou { position:absolute; top:80px; left:255px; font-family:'Pacifico',cursive; font-weight:400; font-style:normal; font-size:65px; color:#f5f0dc; white-space:nowrap; transform:rotate(7deg); text-shadow:1px 2px 4px rgba(0,0,0,0.2); z-index:10; }
          `}</style>
          <div
            style={{
              transform: "scale(0.5)",
              transformOrigin: "top center",
              height: "190px",
              marginBottom: "0px",
              marginTop: "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="composition">
              <div className="yellow-block">
                <span className="text-look">LOOK</span>
              </div>
              <div className="pink-block">
                <span className="text-doingit">DOING IT</span>
              </div>
              <span className="text-atyou">at you</span>
              <span
                style={{
                  position: "absolute",
                  top: "180px",
                  left: "400px",
                  fontFamily: "'Saira Extra Condensed',Impact,sans-serif",
                  fontWeight: 500,
                  fontSize: "160px",
                  color: "#f5f0dc",
                  lineHeight: 1,
                  letterSpacing: "-4px",
                  transform: "scaleY(1.15)",
                  zIndex: 6,
                }}
              >
                !
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          background: "linear-gradient(135deg,#1b608a,#2a84b5,#4aafd4)",
          padding: "12px 20px 14px",
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: 260, margin: "0 auto" }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
            <span style={{ fontSize: 9, letterSpacing: 2, color: "rgba(255,255,255,0.65)", textTransform: "uppercase" }}>
              your week
            </span>
            <span style={{ fontSize: 9, color: "rgba(255,255,255,0.65)" }}>
              {weekDone}/{weekTotal}
            </span>
          </div>
          <div style={{ height: 6, background: "rgba(255,255,255,0.2)", borderRadius: 99, overflow: "hidden" }}>
            <div
              style={{
                height: "100%",
                width: `${weekPct}%`,
                background: T.white,
                borderRadius: 99,
                transition: "width 0.6s ease",
                opacity: 0.9,
              }}
            />
          </div>
          <div style={{ marginTop: 4, fontSize: 10, color: "rgba(255,255,255,0.7)", textAlign: "right" }}>
            {weekPct}% complete
          </div>
        </div>
      </div>
    </>
  );
}
